/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_TitleInputs */

const en_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWF Metadata`)
};

const fr_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées BWF`)
};

const de_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWF-Metadaten`)
};

const it_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati BWF`)
};

const ru_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные BWF`)
};

const es_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos BWF`)
};

const zh_cn2_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWF 元数据`)
};

const ja_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWFメタデータ`)
};

const hi_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीडब्ल्यूएफ मेटाडेटा`)
};

const pt_pt2_audio_description_export_bwf_title = /** @type {(inputs: Audio_Description_Export_Bwf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados BWF`)
};

/**
* | output |
* | --- |
* | "BWF Metadata" |
*
* @param {Audio_Description_Export_Bwf_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_title = /** @type {((inputs?: Audio_Description_Export_Bwf_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_title(inputs)
	if (locale === "de") return de_audio_description_export_bwf_title(inputs)
	if (locale === "it") return it_audio_description_export_bwf_title(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_title(inputs)
	if (locale === "es") return es_audio_description_export_bwf_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_title(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_title(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_title(inputs)
	return en_audio_description_export_bwf_title(inputs)
});